<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-12">
          <div class="element-wrapper">
            <div class="element-box">
              <form @submit="guardar">
                <h5 class="form-header">
                  <span v-if="!current.pk">Nueva </span>
                  <span v-if="current.pk">Edicion de </span>
                  Sub Categoria de Categoria
                  <router-link
                    :to="{ name: 'cat-categorias-editar', params: { id: categoria.codigo }}"
                  >{{ categoria.codigo }} - {{ categoria.nombre }}</router-link>
                </h5>
                
                <div class="row">
                  <div class="col-lg-3 col-sm-12 col-md-12">
                    <div class="form-group">
                      <label
                        v-bind:class="{ 'text-danger': current.errors.codigo && current.errors.codigo.length > 0 }"
                      >Código</label>
                      <input
                        v-model="current.codigo"
                        class="form-control"
                        :readonly="current.pk"
                        placeholder="Código"
                        type="text"
                        v-bind:class="{ 'is-invalid': current.errors.codigo && current.errors.codigo.length > 0 }"
                      />
                      <small
                        v-if="current.errors && current.errors.codigo"
                        class="form-text text-danger"
                      >{{ current.errors.codigo[0] }}</small>
                    </div>
                  </div>
                  <div class="col-lg-9 col-sm-12 col-md-12">
                    <div class="form-group">
                      <label
                        v-bind:class="{ 'text-danger': current.errors.nombre && current.errors.nombre.length > 0 }"
                      >Nombre</label>
                      <input
                        v-model="current.nombre"
                        class="form-control"
                        autofocus="autofocus"
                        placeholder="Nombre"
                        v-bind:class="{ 'is-invalid': current.errors.nombre && current.errors.nombre.length > 0 }"
                        type="text"
                      />
                      <small
                        v-if="current.errors && current.errors.nombre"
                        class="form-text text-danger"
                      >{{ current.errors.nombre[0] }}</small>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-4">
                    <div class="form-check">
                      <label class="form-check-label">
                        <input
                          checked
                          class="form-check-input"
                          name="optionsRadios"
                          v-model="current.estatus"
                          type="radio"
                          value="true"
                        />Activa
                      </label>
                    </div>
                    <div class="form-check">
                      <label class="form-check-label">
                        <input
                          class="form-check-input"
                          v-model="current.estatus"
                          name="optionsRadios"
                          type="radio"
                          value="false"
                        />Inactiva
                      </label>
                    </div>
                  </div>
                </div>

                <div class="form-buttons-w">
                  <button class="btn btn-primary" type="submit">Guardar</button>
                  <router-link
                    class="btn btn-default"
                    :to="{ name: 'cat-subcategorias', params: { categoria: categoria.codigo }}"
                  >
                    <i class="fa fa-back"></i>
                    Volver al Listado
                  </router-link>
                </div>
              </form>
              <br>
              <hr>
              <iframe
                  :src="iframeUrl"
                  class="row"
                  style="width: 100%;"
                  frameborder="0"
                  height="800"
                  allowtransparency
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import DynamicService from "@/services/commons/DynamicService";
import PaginationComponent from "@/components/utils/PaginationComponent";
import CategoriaService from "@/services/catalogos/CategoriaService";
import SubCategoriaService from "@/services/catalogos/SubCategoriaService";
import Notifications from "@/notifications/notifications";

export default {
  data() {
    return {
      iframeUrl: '',
      current: {
        errors: {}
      },
      esNuevo: true,
      categoria: {
        codigo: "",
        nombre: ""
      },
      data: []
    };
  },

  computed: {},
  mounted() {
    let self = this;
    if (self.$route.params.id) {
      self.esNuevo = false;
      SubCategoriaService.getById(self.$route.params.id).then(response => {
        self.current = response.data;
        self.current.pk = self.current.codigo;
        self.current.errors = [];
        self.getDashboard()
      });
    }
    self.refreshData();
    
  },

  methods: {
    getDashboard(){
      let self = this;
      DynamicService.getAction('cat', 'subcategoria', self.current.codigo, 'participacion_por_sub_categoria', {}).then(res => {
        self.iframeUrl = res.data.web_url;
      });
    },
    guardar(e) {
      let self = this;
      e.preventDefault();
      var current = Object.assign({}, self.current);
      if (current.codigo == null) {
        delete current.codigo;
      }
      current.categoria = self.$route.params.categoria

      SubCategoriaService.save(current)
        .then(res => {
          self.current = res.data;
          self.current.pk = self.current.codigo;
          self.current.errors = {};
          Notifications.alert.success(
            "Sub Categoria",
            "Se ha guardado la Información."
          );
          self.$router.push({
            name: "cat-subcategorias-editar",
            params: { categoria: self.current.categoria, id: self.current.codigo }
          });
        })
        .catch(error => {
          if (error.response) {
            self.current.errors = error.response.data;
          }
        });
    },
    showModal(e) {
      e.preventDefault();
    },

    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        page: this.currentPage,
        "filter[search]": this.searchtext,
        activo: this.filterActivo
      });
    },
    filterData() {
      this.refreshData({
        page: 1,
        categoria: this.current.codigo,
        "filter[search]": this.searchtext,
        activo: this.filterActivo
      });
    },
    clearFilterData() {
      this.searchtext = "";
      this.filterActivo = null;
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        activo: this.filterActivo
      });
    },
    hide: function() {
      this.$data.destroy();
    },
    onRefreshData() {},
    refreshData(params) {
      let self = this;
      if (params == undefined) {
        params = {
          categoria: this.$route.params.categoria
        };
      } else {
        params.categoria = this.$route.params.categoria;
      }
      
      SubCategoriaService.fetch(params).then(res => {
        self.data = res.data;
      });
      CategoriaService.getById(this.$route.params.categoria).then(response => {
        self.categoria = response.data;
        self.categoria.errors = [];
      });
    }
  }
};
</script>
